import { useEffect } from "react";
import React from "react";
import Lenis from "lenis";
import { motion, useScroll, useSpring } from "framer-motion";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import LegalPage from "./pages/LegalPage";
import TeamPage from "./pages/TeamPage";
import AbacicoPage from "./pages/AbacicoPage";
import AssistenzaPage from "./pages/AssistenzaPage";
import SmartContractPage from "./pages/SmartContractPage";
import TokenomicsPage from "./pages/TokenomicsPage";
import WhitePaperPage from "./pages/WhitePaperPage";
import OttieniGratisPage from "./pages/OttieniGratisPage";
import Navbar from "./components/Navbar";
import CookieBanner from "./components/CookieBanner";
import HomeTitle from "./components/HomeTitle";
import About from "./components/About";
import Identity from "./components/Identity";
import Mission from "./components/Mission";
import Collab from "./components/Collab";
import Donations from "./components/Donations";
import Roadmap from "./components/Roadmap";
import Pioneers from "./components/Pioneers";
import FAQ from "./components/FAQ";
import AudioBozza from "./components/AudioBozza";
import FundsUse from "./components/FundsUse";
import Quotes from "./components/Quotes";
import Footer from "./components/Footer";

if (typeof history !== "undefined" && "scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-[#F8FAFC] text-slate-700 p-8 text-center">
          <p>USTP — Universe Score Token Protocol</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true, smoothWheel: true });
    lenis.scrollTo(0, { immediate: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function SiteApp() {
  const { scrollYProgress } = useScroll();  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <SmoothScroll />
        <div className="min-h-screen bg-[#F8FAFC] text-slate-900 antialiased selection:bg-sky-200 selection:text-sky-950">
          <motion.div
            style={{ scaleX }}
            data-testid="scroll-progress"
            className="fixed top-0 inset-x-0 h-[3px] z-[60] origin-left bg-gradient-to-r from-sky-600 via-cyan-400 to-amber-400"
          />
          <Navbar />
          <CookieBanner />
          <main className="pt-6 sm:pt-8">
            <HomeTitle />
            <About />
            <Identity />
            <Roadmap />
            <Mission />
            <Collab />
            <Donations />
            <Pioneers />
            <FAQ />
            <Quotes />
            <AudioBozza />
            <FundsUse />
          </main>
          <Footer />
          <Toaster position="bottom-right" richColors closeButton />
        </div>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

function isLegalPath() {
  const p = window.location.pathname.replace(/\/+$/, "");
  return p.endsWith("/privacy") || p.endsWith("/cookie") || p.endsWith("/abacico") || p.endsWith("/assistenza") || p.endsWith("/team") || p.endsWith("/smart-contract") || p.endsWith("/tokenomics") || p.endsWith("/whitepaper") || p.endsWith("/ottieni-gratis");
}

export default function App() {
  const p = window.location.pathname.replace(/\/+$/, "");
  if (p.endsWith("/privacy")) return <LegalPage kind="privacy" />;
  if (p.endsWith("/cookie")) return <LegalPage kind="cookie" />;
  if (p.endsWith("/team")) return <TeamPage />;
  if (p.endsWith("/abacico")) return <AbacicoPage />;
  if (p.endsWith("/assistenza")) return <AssistenzaPage />;
  if (p.endsWith("/smart-contract")) return <SmartContractPage />;
  if (p.endsWith("/tokenomics")) return <TokenomicsPage />;
  if (p.endsWith("/whitepaper")) return <WhitePaperPage />;
  if (p.endsWith("/ottieni-gratis")) return <OttieniGratisPage />;
  return <SiteApp />;
}
